<script>
	window.scrollTo(0, 0);

	import { location } from 'svelte-spa-router';
</script>

<nav class="account-nav">
	<div class="nav-inner">
		<h3>MÔJ ÚČET</h3>
		<ul>
			<li class:active={$location === '/ucet'}><a href="#/ucet">Osobné údaje</a></li>
			<li class:active={$location === '/ucet/objednavky' || $location.match('/ucet/detail-objednavky')}><a href="#/ucet/objednavky">Moje objednávky</a></li>
			<li class:active={$location === '/ucet/adresy' || $location.match('/ucet/detail-adresy') || $location.match('/ucet/nova-adresa')}><a href="#/ucet/adresy">Moje adresy</a></li>
			<li class:active={$location === '/ucet/zmena-hesla'}><a href="#/ucet/zmena-hesla">Zmena hesla</a></li>
		</ul>
	</div>
</nav>

<style>
  .account-nav {
    border: 1px solid var(--color-slate-200);
    background-color: var(--color-slate-50);
    border-radius: 1.5rem;
    padding: 1.5rem;
  	width: fit-content;
  	min-width: 13rem;
    position: relative;
  }
  .account-nav h3 {
    border-bottom: 1px solid var(--color-slate-200);
    padding-bottom: 0.5rem;
    margin-bottom: 1rem;
	color: var(--color-slate-900);
  }
  .account-nav .nav-inner {
    position: sticky;
    top: 1.5rem;
  }
  .account-nav ul {
    list-style-type: none;
    padding-left: 0;
  }
  .account-nav ul li {
    margin: 1.2rem 0;
    width: fit-content;
  }
  .account-nav ul li a {
    color: var(--color-slate-500);
  }
  .account-nav ul li.active a {
    text-decoration: underline;
  }
  .account-nav ul li:hover a {
    text-decoration: underline;
  }
  .account-nav ul li:last-child {
	  margin-bottom: 0;
  }
  @media (max-width: 991.98px) {
	  .account-nav {
		  width: 100%;
	  }
  }
</style>